import { render } from "./PackingList.vue?vue&type=template&id=ddcad84a"
import script from "./PackingList.vue?vue&type=script&lang=js"
export * from "./PackingList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/Buyback/PackingList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ddcad84a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ddcad84a', __exports__)) {
    api.reload('ddcad84a', __exports__)
  }
  
  module.hot.accept("./PackingList.vue?vue&type=template&id=ddcad84a", () => {
    api.rerender('ddcad84a', render)
  })

}


export default __exports__